import { EncounterQueryFilterDto } from "@/types/EncounterQueryFilter";

import axios from "./axios";

const getAll = async (query?: EncounterQueryFilterDto) => {
  const { data } = await axios.get("/encounter", { params: query });
  return data;
};

const getById = async (id: string) => {
  try {
    const { data } = await axios.get(`/encounter/${id}`);
    return data;
  } catch (e) {
    return null;
  }
};

const start = async (id: string) => {
  const { data } = await axios.put(`/encounter/${id}`, { start: true });
  return data;
};

const finish = async (id: string) => {
  const { data } = await axios.put(`/encounter/${id}`, { finish: true });
  return data;
};

export const EncountersAPI = {
  getAll,
  getById,
  start,
  finish,
};
